const MODULE_URL = 'favorite_hubs';

export default {
  MODULE_URL: MODULE_URL,
  HUBS_URL: MODULE_URL,

  VIEW_ID: 'favorite_hub',
};
